// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-reset{display:flex;align-items:center;cursor:pointer;color:#b0b0b0;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.button-reset__icon{margin-right:4px;height:17px;width:17px;transform:translateY(-1px)}@media (hover),(min--moz-device-pixel-ratio:0),(min-width:0\\0){.button-reset:hover{color:#6c6c6c}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
